// 获取chatGPT回复
import { environment } from './index';

export const getChatGPTResultService = async ({ headers, data, extraData }: any) => {
    const { questionTag, isCreateQa, question, oldLucaAskChatId, abortChatSseRequest } = extraData;
    const controller = new AbortController();
    abortChatSseRequest.current = (reason: string) => controller.abort(reason);
    const response: Response = await fetch(`${environment.getApigateWay()}/athena/api/v1/front/luca-ask/chat-sse`, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
        signal: controller.signal,
    });
    const lucaRecordId = response.headers.get('Luca-Record-Id')!;
    const newestLucaAskChatId = response.headers.get('Luca-Ask-Chat-Id')!;
    const userRecordId = response.headers.get('User-Record-Id')!;
    const isLastAskAgain = response.headers.get('Last-Ask-Again')!;
    const botChatIdOfStream = response.headers.get('Bot-Chat-Id')!;
    const needUpdateUserRecordId = data.role !== 'function' && userRecordId;
    const needRefineProblem = Boolean(
        questionTag !== 1 && newestLucaAskChatId && data.role !== 'function' && !data.isContinue && !data.retryType
    );
    return {
        isCreateQa,
        question,
        newestLucaAskChatId: newestLucaAskChatId || oldLucaAskChatId,
        userRecordId,
        lucaRecordId,
        isLastAskAgain,
        botChatIdOfStream,
        needUpdateUserRecordId,
        needRefineProblem,
        reader: response.body!.getReader(),
    };
};

// 解码流
export const decodeStream = (reader: any) => {
    return new TextDecoder('utf-8').decode(reader, { stream: true });
};
